// extracted by mini-css-extract-plugin
module.exports = {"box--xs":"IconBox_box--xs__P5rS8","box--sm":"IconBox_box--sm__RPkqL","box--md":"IconBox_box--md__tzedw","box--lg":"IconBox_box--lg__Unzab"};